<template lang="pug">
  #admin-super-stats-reporting
    BCollapse.card(
      aria-id="programReports"
      :open.sync="programOpen"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='programReports'
      )
        .card-header-title
          | Program Stats
        a.card-header-icon
          BIcon(:icon="programOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      ProgramReportsAdminSuper
</template>

<script>
import ProgramReportsAdminSuper from "@@/StatsReportingAdminSuper/ProgramReportsAdminSuper";

export default {
  name: "AdminSuperStatsReporting",

  components: { ProgramReportsAdminSuper },

  data() {
    return {
      programOpen: true
    };
  }
};
</script>

<style lang="sass" scoped></style>
